<template>
    <fullscreen direction="down">
        <div
            :class="[
                'operational position--relative',
                ( show.operationalArea ) ? 'operational--area' : 'operational--screen display--flex'
            ]"
        >
        <transition v-if="isMounted" name="fade" mode="out-in" appear >
            <div v-if="show.operationalArea" class="operational__content">
                <slot name="operational__area" />
            </div>
            <template v-else>
                <screen
                    v-if="show.screen"
                    :settings="{
                        messages: {
                            request: $t('global.gettingContactRequest'),
                            errorOnRegist: $t('error.regist'),
                            noRequestCall: $t('error.requestCall'),
                            requestCall: $t('global.initiatingCall')
                        },
                        toggles: {
                            ...screen.settings.toggles,
                            errorOnRegist
                        },
                        loading: screen.settings.loading && !errorOnRegist,
                        error: errorOnRegist,
                        showError: screen.settings.showError
                    }"
                />
                <div v-else class="operational__screen">
                    <slot name="operational__screen__center" />
                </div>
            </template>
        </transition>
        </div>
        <slot name="operational__settings" />
        <button-with-icon-and-text
            v-if="show.closeButton"
            :icon="{
                component: () => import( /* webpackChunkName: 'IconCloseBig' */ '@/components/bundles/layout/images/icons/IconCloseBig' )
            }"
            :text="$t('global.leave')"
            class="operational__settings__close position--absolute display--flex"
            :class="[ { 'is-disabled' : screen.settings.toggles.disabledButton } ]"
            :action="{
                execute: true,
                function: () => closeAction( true )
            }"
            :disabled="screen.settings.toggles.disabledButton"
        />
        <modal
            v-if="openModal"
            :form="{
                class: 'operational__modal'
            }"
            :customSettings="{
                class: 'operational__modal__content',
                position: 'center',
                button: {
                    label: 'leave',
                    type: 'button',
                    action: () => closeAction( true )
                }
            }"
            @close="openModal = false"
            :key="openModal"
        >
            <template #modal__header >
                <h2 class="operational__modal__header">{{ $t('global.confirm') }}</h2>
            </template>
            <template #modal__body__confirm >
                <span class="operational__modal__info display--block capitalize">{{ $t('global.areYouSureYouWantToLeave') }}</span>
            </template>
            <template #modal__info >
                <base-button
                    class="modal__content__button--negative background--transparent border--grey"
                    @click="openModal = false"
                    v-html="$t('global.cancel')"
                />
            </template>
        </modal>
    </fullscreen>
</template>

<script>
// packages
import {
    onMounted,
    onUnmounted,
    reactive,
    toRefs,
    watch
} from '@vue/composition-api';

// jssip
import { initJsSIP } from '@/plugins/jssip';

export default {
    components: {
        Fullscreen: () => import( /* webpackChunkName: 'Fullscreen' */ '@/components/bundles/layout/fullscreen/Fullscreen' ),
        Screen: () => import( /* webpackChunkName: 'Screen' */ '@/components/bundles/operate/blocks/Screen' ),
        ButtonWithIconAndText: () => import(
            /* webpackChunkName: 'ButtonWithIconAndText' */ '@/components/bundles/buttons/BaseButtonWithIconAndText'
        ),
        Modal: () => import( /* webpackChunkName: 'Modal' */ '@/components/bundles/layout/modals/Modal' ),
        BaseButton: () => import( /* webpackChunkName: 'BaseButton' */ '@/components/bundles/buttons/BaseButton' )
    },
    props: {
        show: Object,
        screen: Object,
        closeAction: Function,
        init: Function
    },
    setup ( props ) {
        const bools = reactive({
            loading: true,
            isMounted: false,
            openModal: false,
            errorOnRegist: false
        });

        /**
         * [method]
         * Iniciação das configurações do menu.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */

        const initMenu = () => {
            bools.isMounted = true;

            // registo no freeswitch
            const { isRegisted } = initJsSIP();

            // validação se foi feito registo com sucesso
            // - caso tenha, é feito o pedido a API do pedido de contacto;
            // - caso não tenha, é apresentado uma mensagem de erro ao
            //   utilizador e fecha o menu de operador.
            watch( () => isRegisted.value,
                newIsRegisted => {
                    newIsRegisted ? props.init() : setTimeout( existErrorOnRegister, 200 );
                });
        };

        const existErrorOnRegister = () => {
            bools.errorOnRegist = true;
            setTimeout( props.closeAction, 3500 );
        };

        setTimeout( initMenu, 500 );

        onMounted( () => {
            // remoção do scroll na página
            document.body.classList.add( 'overflow--hidden' );
        });

        onUnmounted( () => {
            // adição do scroll na página
            document.body.classList.remove( 'overflow--hidden' );
        });

        return { ...toRefs( bools ) };
    }
};
</script>

<style lang="scss">
    .operational {
        width: inherit;
        justify-content: center;
        &--screen {
            text-align: center;
        }
        &__settings {
            &__close {
                align-items: center;
                justify-content: center;
                @include transform-position( flalse, 0, 15%, 0 );
                margin: auto;
                width: 94px;
                gap: 10px;
                background: $color-white;
                border-radius: 30px;
                .line {
                    @include transition( stroke .3s ease-in-out );
                    will-change: stroke;
                    stroke: $color-red;
                }
                span {
                    text-transform: capitalize;
                    @include typography-specs( 16px, 26px, 400 );
                }
                svg{
                    width: 10px;
                }
            }
        }
        &__modal {
            &__header {
                @include typography-specs( 25px, 33px, 700 );
            }
            &__content {
                max-width: 480px;
            }
        }
    }
    .is-disabled{
        cursor: not-allowed;
    }
</style>